import React, { Component } from 'react'
import { Slider } from 'antd'
import F from "../../../Functions";

export default class SliderLayout extends Component {
  render() {
    const { marks, value, name, updateField, updateRadioBtnToggle } = this.props;
    return (
      <div>
        <Slider
          className="rangeSlider"
          marks={marks}
          step={null}
          value={value}
          included={true}
          tipFormatter={(val) => F.rangeSliderFormatter(val, marks)}
          onChange={(val) => {
            updateField(name, F.sliderValue(val, marks));
              updateRadioBtnToggle();
          }}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/sliderlayout.js